import { Spin } from "antd";
import { useDocumentContentLink } from "../../document/hooks/document-content/use-document-content-link";
import { Table } from "../../../components";
import ColumnGroup from "antd/lib/table/ColumnGroup";
import Column from "antd/lib/table/Column";
import { StringHelper } from "../../../helper";

export const FullDocumentLinkTable = () => {
  const { data, isLoading } = useDocumentContentLink();

  if (isLoading) return <Spin />;

  return (
    <Table dataSource={data} bordered>
      <ColumnGroup title="Tài liệu liên kết">
        <Column title="Mã tài liệu" dataIndex="docCode" key="docCode" />
        <Column title="Tên tài liệu" dataIndex="Title" key="Title" />
        <Column
          title="Các mục liên kết"
          dataIndex="docLinkPosition"
          key="docLinkPosition"
          render={(record) => <div style={{ whiteSpace: "normal" }}>{StringHelper.escapeString(record)}</div>}
        />
        <Column
          title="Nội dung"
          dataIndex="Content"
          key="Content"
          render={(record: string) => (
            <div
              style={{ whiteSpace: "normal", cursor: "pointer", width: "400px" }}
              dangerouslySetInnerHTML={{ __html: record }}
            />
          )}
        />
      </ColumnGroup>
      <ColumnGroup title="Tài liệu được liên kết">
        <Column title="Mã tài liệu" dataIndex="docLinkType" key="docLinkType" />
        <Column title="Tên tài liệu" dataIndex="docLinkTitle" key="docLinkTitle" />
      </ColumnGroup>
    </Table>
  );
};
